import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import WalletOutlinedIcon from '@mui/icons-material/WalletOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { FormattedMessage } from "react-intl";
import { useConstants } from "../hooks/UseConstants";
import AppSidebarShell from "./layout/AppSidebarShell";

function Sidebar() {
    const { language } = useConstants();
    const { wait } = useContext(AuthContext);
    const isAr = language === 'ar';

    const sections = [
        {
            label: isAr ? 'الرئيسية' : 'Main',
            items: [
                { title: <FormattedMessage id="dashboard" />, icon: DashboardOutlinedIcon, link: '/dashboard', end: true },
                { title: <FormattedMessage id="notifications" />, icon: NotificationsNoneOutlinedIcon, link: '/notifications' },
            ],
        },
        {
            label: isAr ? 'الإدارة' : 'Management',
            items: [
                { title: <FormattedMessage id="approval_requests" />, icon: CheckCircleOutlineIcon, link: '/accept-requests' },
                { title: <FormattedMessage id="students" />, icon: SchoolOutlinedIcon, link: '/students' },
                { title: <FormattedMessage id="teachers" />, icon: PeopleOutlineIcon, link: '/teachers' },
                { title: <FormattedMessage id="courses" />, icon: CastForEducationOutlinedIcon, link: '/courses' },
            ],
        },
        {
            label: isAr ? 'المحتوى' : 'Content',
            items: [
                { title: <FormattedMessage id="ads" />, icon: CampaignOutlinedIcon, link: '/ads' },
                { title: <FormattedMessage id="academic_categories" />, icon: CategoryOutlinedIcon, link: '/categories' },
                { title: <FormattedMessage id="academic_structure" />, icon: AccountTreeOutlinedIcon, link: '/academic-structure' },
            ],
        },
        {
            label: isAr ? 'المالية' : 'Finance',
            items: [
                { title: <FormattedMessage id="financial" />, icon: AccountBalanceWalletOutlinedIcon, link: '/financial' },
                { title: <FormattedMessage id="withdrawal_requests" />, icon: PaymentsOutlinedIcon, link: '/financial/withdrawal-requests' },
                { title: <FormattedMessage id="financial_ledger" />, icon: ReceiptLongOutlinedIcon, link: '/financial/financial-operations' },
                { title: <FormattedMessage id="wallet" />, icon: WalletOutlinedIcon, link: '/wallet' },
                { title: isAr ? 'شحن محفظة طالب' : 'Student top-up', icon: WalletOutlinedIcon, link: '/wallet/student-topup' },
            ],
        },
        {
            label: isAr ? 'النظام' : 'System',
            items: [
                { title: <FormattedMessage id="reports" />, icon: AssessmentOutlinedIcon, link: '/reports' },
            ],
        },
    ];

    return <AppSidebarShell sections={sections} homeLink="/dashboard" show={!wait} />;
}

export default Sidebar;
